const globleData = {
    user:{},
    myService:[]
}

export default globleData
